__turbopack_context__.v({
  "group": "bSlq1W_group",
  "item": "bSlq1W_item",
});
